import Maintenance from "./Component/Maintenance";

function App() {
  return <Maintenance />;
}

export default App;
